import React, { useEffect, useState } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import highcharts3d from "highcharts/highcharts-3d";
import { NotificationManager } from 'react-notifications';
import './styles.scss';
import { BsBook, BsCalendarMonth } from "react-icons/bs";
import { MdEditCalendar } from "react-icons/md";
import moment from "moment/moment";
import PopupDashboardComponent from "./popupDashboard";
import { Link } from "react-router-dom";

function DashboardComponent(props) {
    // const [selectedFromDate, setFromDateChange] = useState(new Date().toISOString().substring(0, 10));
    // eslint-disable-next-line
    const [selectedToDate, setToDateChange] = useState(new Date().toISOString().substring(0, 10));
    const [valueChart, setValueChart] = useState([]);
    const [dataName5, setDataName5] = useState();
    const [data5, setData5] = useState();
    const [sumConfirm, setSumConfirm] = useState(0);
    const [sumMonth, setSumMonth] = useState(0);
    const [sumNextWeek, setSumNextWeek] = useState(0);
    const [sumTimeExtend, setSumTimeExtend] = useState(0);
    const [title, setTitle] = useState();
    const [open, setOpen] = useState(false);;
    const [dataDeploy, setDataDeploy] = useState();
    const [dataHotfix, setDataHotfix] = useState();
    const [dataHotRequest, setDataHotRequest] = useState();
    const [headerDeploy, setHeaderDeploy] = useState([]);
    const [headerHotFix, setHeaderHotFix] = useState([]);
    const [headerHotRequest, setHeaderHotReuqest] = useState([]);
    const [type, setType] = useState();
    const [count, setCount] = useState(0);
    const [sumAllConfirm, setSumAllConfirm] = useState(0)

    useEffect(() => {
        // setFromDateChange(getMondayOfCurrentWeek().toISOString().substring(0, 10));
        //const currentDate = new Date();
        const startNextWeek = moment().add(1, 'weeks').startOf('isoWeek').format("YYYY-MM-DD");
        const endNextWeek = moment().add(1, 'weeks').endOf('isoWeek').format("YYYY-MM-DD");
        const firstDateMonthConvert = moment().startOf('month').format("YYYY-MM-DD");
        const endDate = moment(firstDateMonthConvert).add(3, 'months').endOf('month').format("YYYY-MM-DD");
        const DataDashboard = {
            "FromDate": startNextWeek,
            "ToDate": endNextWeek,
            "Value": 1
        };
        const DataDashboard2 = {
            "FromDate": getMondayOfCurrentWeek(),
            "ToDate": selectedToDate,
            "Value": 2
        };
        const DataDashboard3 = {
            "FromDate": getMondayOfCurrentWeek(),
            "ToDate": selectedToDate,
            "Value": 3
        };
        const DataDashboard4 = {
            "FromDate": getMondayOfCurrentWeek(),
            "ToDate": selectedToDate,
            "Value": 4
        };
        const DataDashboard5 = {
            "FromDate": getMondayOfCurrentWeek(),
            "ToDate": selectedToDate,
            "Value": 5
        };
        const DataDashboard6 = {
            "FromDate": firstDateMonthConvert,
            "ToDate": endDate,
            "Value": 6
        };

        const DataNextWeek = {
            PlanTypeID: 18,
            DataTables: [
                {
                    "Name": "Thời gian dự kiến bắt đầu",
                    "Data": "",
                    "Type": "Datetime Between",
                    "Child": [
                        {
                            "Name": "Thời gian dự kiến bắt đầu",
                            "Data": startNextWeek
                        },
                        {
                            "Name": "Thời gian dự kiến bắt đầu",
                            "Data": endNextWeek
                        }
                    ]
                }
            ]
        };
        const DataTimeExtend = {
            DataTables: [
                {
                    "Name": "Thời gian gia hạn triển khai",
                    "Data": moment().format("YYYY-MM-DD"),
                    "Type": "Datetime",
                    "Child": []
                },
                {
                    "Name": "Lý do gia hạn thời gian triển khai",
                    "Data": " ",
                    "Type": "Input text",
                    "Child": []
                }
            ]
        }
        props.GetDataDashboard(DataDashboard);
        props.GetDataDashboard2(DataDashboard2);
        props.GetDataDashboard3(DataDashboard3);
        props.GetDataDashboard4(DataDashboard4);
        props.GetDataDashboard5(DataDashboard5);
        props.GetDataDashboard6(DataDashboard6);
        props.GetDataPlanNextWeekDashboard(DataNextWeek);
        props.GetDataPlanTimeExtendDashboard(DataTimeExtend);
        props.GetDataPlanDashboard();
        //props.GetDataHeaderTableReport(4063);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.DataDashboard4) {
            let value = 0;
            const data = props.DataDashboard4 ? props.DataDashboard4 : [];
            data.map((item, index) => {
                value = item.data;
                return value;
            });
            for (let index = 1; index <= value.length; index++) {
                setValueChart(prev => [...prev, index]);
            }
            let sumPlanMonth = 0;
            // eslint-disable-next-line
            props.DataDashboard4 && props.DataDashboard4.map((item) => {
                const sum = item.data.map(datum => datum).reduce((a, b) => a + b);
                sumPlanMonth = sumPlanMonth + sum;
            })
            setSumMonth(sumPlanMonth);
        }
    }, [props.DataDashboard4]);

    useEffect(() => {
        if (props.DataDashboard5) {
            const name = props.DataDashboard5 && props.DataDashboard5.map((item => { return item.name }));
            const y = props.DataDashboard5 && props.DataDashboard5.map((item => { return item.y }));
            setData5(y);
            setDataName5(name);
            // if (y && y.length !== 0) {
            //     const sum = y.map(datum => datum).reduce((a, b) => a + b);
            //     setSumConfirm(sum);
            // }
        }
    }, [props.DataDashboard5]);

    useEffect(() => {
        if (props.DataPlan) {
            const dataDeployConfirm = JSON.parse(props.DataPlan.dataDeploy).filter((item) => item.Row === 1)
            const dataHotReConfirm = JSON.parse(props.DataPlan.dataHotRequest).filter((item) => item.Row === 1)
            const dataHotfixConfirm = JSON.parse(props.DataPlan.dataHotfix).filter((item) => item.Row === 1)
            if (dataDeployConfirm.length >= 0 && dataHotReConfirm.length >= 0 && dataHotfixConfirm.length >= 0) {
                setSumConfirm(dataDeployConfirm.length + dataHotReConfirm.length + dataHotfixConfirm.length)
                setSumAllConfirm(JSON.parse(props.DataPlan.dataDeploy).length + JSON.parse(props.DataPlan.dataHotRequest).length + JSON.parse(props.DataPlan.dataHotfix).length);
            }
            if (type === 2) {
                setDataDeploy(dataDeployConfirm);
                setDataHotRequest(dataHotReConfirm);
                setDataHotfix(dataHotfixConfirm);
                setOpen(true);
            }
        }
        // eslint-disable-next-line
    }, [props.DataPlan, count])

    //console.log("Type", type);

    useEffect(() => {
        if (props.DataNextWeek) {
            setSumNextWeek(JSON.parse(props.DataNextWeek).length)
            if (type === 1) {
                const datadeploy = props.DataNextWeek ? JSON.parse(props.DataNextWeek) : [];
                const arraySort = datadeploy && datadeploy.map((item) => {
                    return {
                        'Project Name': item['Project Name'],
                        ...item
                    }
                })
                setDataDeploy(arraySort);
                setDataHotRequest([]);
                setDataHotfix([]);
                setOpen(true);
            }
        }
        // eslint-disable-next-line
    }, [props.DataNextWeek, count])

    useEffect(() => {
        if (props.DataTimeExtend) {
            const datatimeExDep = JSON.parse(props.DataTimeExtend.dataDeploy)
            const datatimeExHotre = JSON.parse(props.DataTimeExtend.dataHotRequest)
            const datatimeExHotfix = JSON.parse(props.DataTimeExtend.dataHotfix)
            if (datatimeExDep.length >= 0) {
                setSumTimeExtend(datatimeExDep.length)
            }
            if (type === 3) {
                const arraySortDep = datatimeExDep && datatimeExDep.map((item) => {
                    return {
                        'Project Name': item['Project Name'],
                        'Thời gian gia hạn triển khai': item['Thời gian gia hạn triển khai'],
                        'Lý do gia hạn thời gian triển khai': item['Lý do gia hạn thời gian triển khai'],
                        ...item
                    }
                })
                const arraySortHotRe = datatimeExHotre && datatimeExHotre.map((item) => {
                    return {
                        'Project Name': item['Project Name'],
                        ...item
                    }
                })
                const arraySortHotFix = datatimeExHotfix && datatimeExHotfix.map((item) => {
                    return {
                        'Project Name': item['Project Name'],
                        ...item
                    }
                })
                setDataDeploy(arraySortDep);
                setDataHotRequest(arraySortHotRe);
                setDataHotfix(arraySortHotFix);
                setOpen(true);
            }
        }
        // eslint-disable-next-line
    }, [props.DataTimeExtend, count])
    useEffect(() => {
        if (dataDeploy && dataDeploy.length > 0) {
            let dataheader = Object.keys(dataDeploy[0]);
            let arrayColumn = [];
            // eslint-disable-next-line
            dataheader && dataheader.map((item, index) => {
                if (index === 0) {
                    arrayColumn.push({
                        title: item,
                        field: item,
                        filtering: false,
                        editable: "never",
                        render: (rowData) => (
                            <Link to={"/PlanHandle/PlanHandleStep/" + rowData.PlanID} target="_blank">
                                {rowData[Object.keys(rowData)[0]]}
                            </Link>
                        ),
                    });
                } else {
                    if (item === 'PlanID' || item === 'CreateBy' || item === 'Admin' || item === 'EditBy' || item === 'Row' ||
                        item === 'CreateDate' || item === 'Status2' || item === "HandleStep" || item === "Email" || item === "Assignee") {
                        arrayColumn.push({
                            title: item,
                            field: item,
                            hidden: true
                        })
                    }
                    else if (type === 1 && (item === "Lý do gia hạn thời gian triển khai" || item === "Thời gian gia hạn triển khai")) {
                        arrayColumn.push({
                            title: item,
                            field: item,
                            hidden: true
                        })
                    }
                    else {
                        arrayColumn.push({
                            title: item,
                            field: item,
                            filtering: false,
                            editable: "never",
                        });
                    }
                }
            });
            setHeaderDeploy(arrayColumn);
        }
    // eslint-disable-next-line
    }, [dataDeploy])

    useEffect(() => {
        if (dataHotRequest && dataHotRequest.length > 0) {
            let dataheader = Object.keys(dataHotRequest[0]);
            let arrayColumn = [];
            // eslint-disable-next-line
            dataheader && dataheader.map((item, index) => {
                if (index === 0) {
                    arrayColumn.push({
                        title: item,
                        field: item,
                        filtering: false,
                        editable: "never",
                        render: (rowData) => (
                            <Link to={"/PlanHandle/PlanHandleStep/" + rowData.PlanID} target="_blank">
                                {rowData[Object.keys(rowData)[0]]}
                            </Link>
                        ),
                    });
                } else {
                    if (item === 'PlanID' || item === 'CreateBy' || item === 'Admin' || item === 'EditBy' || item === 'Row' ||
                        item === 'CreateDate' || item === 'Status2' || item === "HandleStep" || item === "Email" || item === "Assignee") {
                        arrayColumn.push({
                            title: item,
                            field: item,
                            hidden: true
                        })
                    }
                    else {
                        arrayColumn.push({
                            title: item,
                            field: item,
                            filtering: false,
                            editable: "never",
                        });
                    }
                }
            });
            setHeaderHotReuqest(arrayColumn);
        }

    }, [dataHotRequest])
    useEffect(() => {
        if (dataHotfix && dataHotfix.length > 0) {
            let dataheader = Object.keys(dataHotfix[0]);
            let arrayColumn = [];
            // eslint-disable-next-line
            dataheader && dataheader.map((item, index) => {
                if (index === 0) {
                    arrayColumn.push({
                        title: item,
                        field: item,
                        filtering: false,
                        editable: "never",
                        render: (rowData) => (
                            <Link to={"/PlanHandle/PlanHandleStep/" + rowData.PlanID} target="_blank">
                                {rowData[Object.keys(rowData)[0]]}
                            </Link>
                        ),
                    });
                } else {
                    if (item === 'PlanID' || item === 'CreateBy' || item === 'Admin' || item === 'EditBy' || item === 'Row' ||
                        item === 'CreateDate' || item === 'Status2' || item === "HandleStep" || item === "Email" || item === "Assignee") {
                        arrayColumn.push({
                            title: item,
                            field: item,
                            hidden: true
                        })
                    }
                    else {
                        arrayColumn.push({
                            title: item,
                            field: item,
                            filtering: false,
                            editable: "never",
                        });
                    }
                }
            });
            setHeaderHotFix(arrayColumn);
        }

    }, [dataHotfix])

    const getMondayOfCurrentWeek = () => {
        const today = new Date();

        if (today.getDay() === 0) {
            const first = today.getDate() - 6;
            const monday = new Date(today.setDate(first));
            return monday
        }
        else {
            const first = today.getDate() - today.getDay() + 1;

            const monday = new Date(today.setDate(first));
            return monday;
        }
    }
    const options = (text, data) => {
        return {
            chart: {
                backgroundColor: 'var(--itsm-card-bg-color)',
                type: 'pie',
                options3d: {
                    enabled: true,
                    alpha: 70,
                    beta: 0
                },
                style: {
                    fontFamily: 'Arial, Helvetica, Clean, sans-serif',
                    borderRadius: '10px',
                    width: '99%'
                    //height: 350
                }
            },
            title: {
                text: text,
                style:
                {
                    color: 'rgb(63, 203, 200)',
                    fontSize: '13px'
                }
            },
            tooltip: {
                style:
                {
                    fontSize: '17px',
                    backgroundColor: 'var(--itsm-card-bg-color)',
                }
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    //innerSize: 100,
                    depth: 40,
                    allowPointSelect: true,
                    cursor: 'pointer',
                    // colors: [
                    //     'var(--default-green)',
                    //     'var(--dark-green)',
                    //     'var(--dark-cyan-blue)',
                    // ],
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>',
                        style:
                        {
                            width: '65px',
                            fontSize: '15px'
                        }
                    },
                    //size:'100%'
                }
            },
            series: [{
                type: 'pie',
                name: 'Số lượng',
                data: data ? data : []
            }]
        }
    };
    const options4 = {
        chart: {
            backgroundColor: 'var(--itsm-card-bg-color)',
            type: 'line',
            style: {
                fontFamily: 'Arial, Helvetica, Clean, sans-serif',
                borderRadius: '10px',
                width: '99%'
            }
        },
        title: {
            text: '<b>Các loại kế hoạch tạo trong tháng</b>',
            style:
            {
                color: '#F25C54',
                fontSize: '13px'
            }
        },
        xAxis: {
            categories: valueChart
        },
        credits: {
            enabled: false,
        },
        yAxis: {
            title: {
                text: 'Số lượng kế hoạch'
            }
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true,
                },
                enableMouseTracking: false,
            }
        },
        series: props.DataDashboard4 ? props.DataDashboard4 : [],
    }
    highcharts3d(Highcharts)
    const options5 = {
        chart: {
            type: 'column',
            style: {
                borderRadius: '10px',
                width: '99%'
            }
        },
        title: {
            text: 'Kế hoạch đang chờ bạn xác nhận',
            style:
            {
                color: 'rgb(63, 203, 200)',
                fontSize: '13px',
                fontFamily: 'Arial, Helvetica, Clean, sans-serif',
                fontWeight: 'bold'
            }
        },
        credits: {
            enabled: false,
        },
        xAxis: {
            categories: dataName5,
            crosshair: true
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Số lượng'
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="padding:0"><b>{point.y} </b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [{
            name: 'Chưa xác nhận',
            showInLegend: false,
            data: data5
        }]
    }
    const options6 = {
        chart: {
            style: {
                borderRadius: '10px',
                width: '98.5%'
            }
        },
        rangeSelector: {
            //selected: 0,
            //enabled: false,
            //inputEnabled: true,
            //allButtonsEnabled: true
            //inputDateFormat: '%Y-%m-%d',
            enabled: false
        },
        title: {
            text: "Các Kế hoạch Deployment_Normal dự kiến sắp tới",
            style:
            {
                color: '#F25C54',
                fontSize: '13px',
                fontFamily: 'Arial, Helvetica, Clean, sans-serif',
                fontWeight: 'bold'
            }
        },
        tooltip: {
            split: true
        },
        credits: {
            enabled: false,
        },
        yAxis: {
            opposite: false
        },
        series: [
            {
                name: 'Số lượng',
                data: props.DataDashboard6,
                // tooltip: {
                //     valueDecimals: 2
                // }
            }
        ]
    };

    const HandleClickConfirm = () => {
        if (sumConfirm === 0) {
            NotificationManager.warning("Không có dữ liệu kế hoạch chờ bạn xác nhận !");
        }
        else {
            setTitle("Kế hoạch chờ bạn xác nhận");
            props.GetDataPlanDashboard();
            setType(2)
            const DataDashboard5 = {
                "FromDate": getMondayOfCurrentWeek(),
                "ToDate": selectedToDate,
                "Value": 5
            };
            props.GetDataDashboard5(DataDashboard5);
            setCount(count + 1);
        }
    }
    const handleClose = () => {
        setOpen(false);
    }
    const HandlePlanNextWeek = () => {
        if (sumNextWeek === 0) {
            NotificationManager.warning("Không có dữ liệu kế hoạch deploy tuần kế tiếp !");
        }
        else {
            const startNextWeek = moment().add(1, 'weeks').startOf('isoWeek').format("YYYY-MM-DD");
            const endNextWeek = moment().add(1, 'weeks').endOf('isoWeek').format("YYYY-MM-DD");
            const DataNextWeek = {
                PlanTypeID: 18,
                DataTables: [
                    {
                        "Name": "Thời gian dự kiến bắt đầu",
                        "Data": "",
                        "Type": "Datetime Between",
                        "Child": [
                            {
                                "Name": "Thời gian dự kiến bắt đầu",
                                "Data": startNextWeek
                            },
                            {
                                "Name": "Thời gian dự kiến bắt đầu",
                                "Data": endNextWeek
                            }
                        ]
                    }
                ]
            };
            setTitle("Kế hoạch dự kiến trong tuần kế tiếp");
            setType(1)
            props.GetDataPlanNextWeekDashboard(DataNextWeek);
            setCount(count + 1);
        }
    }
    const HandleClickExtend = () => {
        if (sumTimeExtend === 0) {
            NotificationManager.warning("Không có dữ liệu kế hoạch gia hạn trong ngày !");
        }
        else {
            const DataTimeExtend = {
                DataTables: [
                    {
                        "Name": "Thời gian gia hạn triển khai",
                        "Data": moment().format("YYYY-MM-DD"),
                        "Type": "Datetime",
                        "Child": []
                    },
                    {
                        "Name": "Lý do gia hạn thời gian triển khai",
                        "Data": " ",
                        "Type": "Input text",
                        "Child": []
                    }
                ]
            }
            setType(3)
            props.GetDataPlanTimeExtendDashboard(DataTimeExtend);
            setTitle("Kế hoạch gia hạn trong ngày");
            setCount(count + 1);
        }
    }

    return (
        <div className="Body" style={{ backgroundColor: 'transparent', height: '100%' }}>
            <b className="ml-1" style={{ fontSize: 20 }}>Change Management Dashboard</b>
            <div className="dboverview mb-3 row">
                <div className="dbcl col-md-3 col-ms-6 mb-1">
                    <div className="db nextwwek" onClick={HandlePlanNextWeek}>
                        <div className="row w-100">
                            <div className="col-2 tabletdIcon">
                                <BsBook className="tableIcon" />
                            </div>
                            <div className="col-10 dbinfor">
                                <div className="row dbtextnumber">
                                    {sumNextWeek}
                                </div>
                                <div className="row dbtext">
                                    Kế hoạch dự kiến tuần kế tiếp
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dbcl col-md-3 col-ms-6 md-1">
                    <div className="db confirm" onClick={HandleClickConfirm}>
                        <div className="row">
                            <div className="col-2 tabletdIcon">
                                <MdEditCalendar className="tableIcon" />
                            </div>
                            <div className="col-10 dbinfor">
                                <div className="row dbtextnumber">
                                    {sumConfirm}/{sumAllConfirm}
                                </div>
                                <div className="row dbtext">
                                    KH chờ bạn xác nhận/ tổng KH của bạn
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dbcl col-md-3 col-ms-6 mb-1">
                    <div className="db extend" onClick={HandleClickExtend}>
                        <div className="row">
                            <div className="col-2 tabletdIcon">
                                <BsBook className="tableIcon" />
                            </div>
                            <div className="col-10 dbinfor">
                                <div className="row dbtextnumber">
                                    {sumTimeExtend}
                                </div>
                                <div className="row dbtext">
                                    Kế hoạch gia hạn trong ngày
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dbcl col-md-3 col-ms-6 mb-1">
                    <div className="db month">
                        <div className="row">
                            <div className="col-2 tabletdIcon">
                                <BsCalendarMonth className="tableIcon" />
                            </div>
                            <div className="col-10 dbinfor">
                                <div className="row dbtextnumber">
                                    {sumMonth}
                                </div>
                                <div className="row dbtext">
                                    Kế hoạch trong tháng
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-3 dbchart">
                <div className="db column">
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options5}
                    />
                </div>
                <div className="db line">
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options4}
                    />
                </div>
            </div>
            <div className="row mb-3 dbchart">
                <div className="db column">
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options("<b>Kết quả sau triển khai theo tuần</b>", props.DataDashboard2)}
                    />
                </div>
                <div className="db line">
                    <HighchartsReact
                        highcharts={Highcharts}
                        constructorType={"stockChart"}
                        options={options6}
                    />
                </div>
            </div>
            <div className="row mb-3 dbpie">
                {
                    props.DataDashboard3 && props.DataDashboard3.map((item, index) => {
                        return (
                            <div className="col-4">
                                <div className="mb-3 db" key={index} style={{ borderRadius: '10px' }}>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={options("<b>Kết quả sau triển khai " + item.title + " theo tuần </b>", item.responeDashboards)}
                                    />
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <div className="dbPopup">
                <PopupDashboardComponent
                    open={open}
                    dataDeploy={dataDeploy ? dataDeploy : []}
                    dataHotfix={dataHotfix ? dataHotfix : []}
                    dataHotRequest={dataHotRequest ? dataHotRequest : []}
                    titleDashboard={title}
                    handleClose={handleClose}
                    headerDeploy={headerDeploy}
                    headerHotFix={headerHotFix}
                    headerHotRequest={headerHotRequest}
                />
            </div>
        </div>
    )
}
export default DashboardComponent;